module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "googleDriveIcon"
    }
  }, [_c('svg', {
    attrs: {
      "width": "104px",
      "height": "104px",
      "viewBox": "0 0 104 104",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('clicked')
      }
    }
  }, [_c('defs', [_c('circle', {
    attrs: {
      "id": "path-1",
      "cx": "36",
      "cy": "36",
      "r": "36"
    }
  }), _vm._v(" "), _c('filter', {
    attrs: {
      "x": "-37.5%",
      "y": "-29.2%",
      "width": "175.0%",
      "height": "175.0%",
      "filterUnits": "objectBoundingBox",
      "id": "filter-2"
    }
  }, [_c('feOffset', {
    attrs: {
      "dx": "0",
      "dy": "6",
      "in": "SourceAlpha",
      "result": "shadowOffsetOuter1"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8",
      "in": "shadowOffsetOuter1",
      "result": "shadowBlurOuter1"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0.0117647059   0 0 0 0 0.0862745098   0 0 0 0 0.160784314  0 0 0 0.08 0",
      "type": "matrix",
      "in": "shadowBlurOuter1",
      "result": "shadowMatrixOuter1"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dx": "0",
      "dy": "1",
      "in": "SourceAlpha",
      "result": "shadowOffsetOuter2"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "1",
      "in": "shadowOffsetOuter2",
      "result": "shadowBlurOuter2"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0.0117647059   0 0 0 0 0.0862745098   0 0 0 0 0.160784314  0 0 0 0.11 0",
      "type": "matrix",
      "in": "shadowBlurOuter2",
      "result": "shadowMatrixOuter2"
    }
  }), _vm._v(" "), _c('feMerge', [_c('feMergeNode', {
    attrs: {
      "in": "shadowMatrixOuter1"
    }
  }), _vm._v(" "), _c('feMergeNode', {
    attrs: {
      "in": "shadowMatrixOuter2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-460.000000, -125.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-4",
      "transform": "translate(412.000000, 129.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Drive-icon-",
      "transform": "translate(58.000000, 0.000000)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "Oval",
      "fill": "#2196F3",
      "opacity": "0.100000001",
      "cx": "42",
      "cy": "42",
      "r": "42"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group",
      "transform": "translate(6.000000, 6.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Oval"
    }
  }, [_c('use', {
    attrs: {
      "fill": "black",
      "fill-opacity": "1",
      "filter": "url(#filter-2)",
      "xlink:href": "#path-1"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "fill": "#FFFFFF",
      "fill-rule": "evenodd",
      "xlink:href": "#path-1"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "google-drive",
      "transform": "translate(20.000000, 22.000000)",
      "fill-rule": "nonzero"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Path",
      "fill": "#FFC107",
      "points": "21.4163769 20.1846154 32 20.1846154 21.4163769 0 10.8307692 0"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Path",
      "fill": "#2196F3",
      "points": "9.97143698 20.1846154 5.41538462 28.0615385 27.01526 28.0615385 32 20.1846154"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Path",
      "fill": "#4CAF50",
      "points": "10.6240847 0 0 18.7070242 5.3130384 28.0615385 15.7538462 9.67722198"
    }
  })])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9dc481ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/gdrive/UploadIcon.vue
// module id = 2246
// module chunks = 0